$ = jQuery;
export const menu = {
  init: function () {
    $(".c-hamburger").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if ($(this).hasClass("is-active")) {
        $(this).removeClass("is-active");
        $("body").removeClass("menu-opened");
      } else {
        $(this).addClass("is-active");
        $("body").addClass("menu-opened");
      }
    });

    $(".c-hamburger-mobile").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if ($(this).hasClass("is-active")) {
        $(this).removeClass("is-active");
        $("body").removeClass("mobile-menu-opened");
      } else {
        $(this).addClass("is-active");
        $("body").addClass("mobile-menu-opened");
      }
    });

    var mm = window.matchMedia("(max-width: 1024px)");
    menuResponsive(mm);
    mm.addListener(menuResponsive);

    function menuResponsive(mm) {
      if (mm.matches) {
        $(".menu-item-has-children").each(function () {
          var $ul = $(this).find("ul");
          var $li = $(this).find("ul li");
          var totalHeight = $li.length * 50;
          $ul.attr("style", `--this-height: ${totalHeight}px`);
          $(this).unbind("mouseenter mouseleave");
          $(this)
            .find("a:first")
            .on("click", function (e) {
              e.preventDefault();
            });
          $(this)
            .find("ul")
            .find("a")
            .on("click", function (e) {
              e.stopPropagation();
            });
          $(this).on("click", function () {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
            } else {
              $(".menu-item-has-children").removeClass("active");
              $(this).addClass("active");
            }
          });
        });
      } else {
        $(".nav-container .menu-item-has-children").each(function () {
          $(this).off("click");
          $(this)
            .find("a:first")
            .on("click", function (e) {
              e.preventDefault();
            });
          $(this).hover(
            function () {
              $(this).addClass("active");
            },
            function () {
              $(this).removeClass("active");
            }
          );
        });
      }
    }
  },
};
